import MaterialType from './MaterialType';

export default {
  PLASTIC: new MaterialType('plastic'),
  FABRIC: new MaterialType('fabric'),
  SAMPLE: new MaterialType('sample')
};
